import { AxiosRequestConfig } from 'axios'
import { CustomerProfile, CustomerProfileRequest } from '../../../../types/customerProfileService'
import { applySearchParams, urlToPathnameAndSearch } from '../../appointments/utils'
import { apiVersion, service } from '../service'

const pathname = `/api/${apiVersion}/customers`

const makeGetCustomerProfile =
  (baseUrl: string, config: AxiosRequestConfig) =>
  async (request: CustomerProfileRequest = {}): Promise<CustomerProfile> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, request as Record<string, string>)

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const { data } = await service(baseUrl).get(pathnameAndSearch, config)

    // It will always return a single profile
    return data.data[0] as CustomerProfile
  }

export { makeGetCustomerProfile }
